/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listTaskTemplates} from '../api'

export const useMutationListTaskTemplates = createReactQueryMutationHook('listTaskTemplates', listTaskTemplates)
